import MainLogo from './MainLogo'
export default MainLogo



// WEBPACK FOOTER //
// ./src/atoms/MainLogo/index.js